var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.object.type === "code"
    ? _c(
        "div",
        [
          _c("div", { staticClass: "text-right mb-2" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.hover",
                    modifiers: { hover: true },
                  },
                ],
                staticClass: "btn btn-link",
                attrs: {
                  title: `Ctrl-F / Cmd-F
Start searching\n
Ctrl-G / Cmd-G
Find next
Shift-Ctrl-G / Shift-Cmd-G
Find previous
Shift-Ctrl-F / Cmd-Option-F
Replace
Shift-Ctrl-R / Shift-Cmd-Option-F
Replace all
Alt-F
Persistent search (dialog doesn't autoclose, enter to find next, Shift-Enter to find previous)
Alt-G
Jump to line`,
                },
              },
              [
                _vm._v("\n        Shortcuts\n        "),
                _c("i", { staticClass: "fas fa-question-circle" }),
              ]
            ),
          ]),
          _c("codemirror", {
            ref: "editor",
            attrs: { options: _vm.codemirrorOptions },
            on: {
              blur: _vm.blurCodemirror,
              input: _vm.validateCodeWithThrottle,
              change: _vm.validateCodeWithThrottle,
            },
            model: {
              value: _vm.mutatedObject[_vm.field],
              callback: function ($$v) {
                _vm.$set(_vm.mutatedObject, _vm.field, $$v)
              },
              expression: "mutatedObject[field]",
            },
          }),
          _vm.codeErrorMessage
            ? _c("div", {
                staticClass: "alert alert-danger my-3",
                domProps: { innerHTML: _vm._s(_vm.codeErrorMessage) },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm.field !== "helpOptions"
    ? _c("advanced-input", {
        class: [_vm.object.class ? _vm.object.class : "form-control"],
        attrs: {
          value: _vm.mutatedObject[_vm.field],
          object: _vm.object,
          field: _vm.field,
          type: _vm.object.type,
          maxSymbols: _vm.object.maxSymbols,
          minSymbols: _vm.object.minSymbols,
          max: _vm.object.max,
          min: _vm.object.min,
          required: _vm.object.required,
          decimal: _vm.object.decimal,
          pattern: _vm.object.pattern,
          readonly: _vm.object.readonly,
          id: `advanced-input-${_vm.id}`,
          placeholder: _vm.object.placeholder ? _vm.object.placeholder : "",
          disabled: _vm.object.disabled,
          validator: _vm.object.validator,
          mask: _vm.object.mask || "",
          autofocus: "",
        },
        model: {
          value: _vm.mutatedObject[_vm.field],
          callback: function ($$v) {
            _vm.$set(_vm.mutatedObject, _vm.field, $$v)
          },
          expression: "mutatedObject[field]",
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }